/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
async function check_pre_order_limit(formElement) {
  let variant_id = parseInt(formElement.querySelector('[name="id"]').value);
  if(formElement.querySelector('#product-preorder-data')) {
    let pre_order_data = JSON.parse(formElement.querySelector('#product-preorder-data').textContent);
    let matchedVariant = pre_order_data.variants.find(variant => variant.variant_id === variant_id);
    let selectedQuantity =  parseInt(formElement.querySelector(".quantity-selector__value").value);
    let pre_order_limit = parseInt(matchedVariant.pre_order_limit);
    return await checkPreorderLimit(variant_id, selectedQuantity, pre_order_limit);
  } else {
    return false; 
  }
}
function getCartQuantity(variantId, callback) {
  fetch('/cart.js')
  .then(response => response.json())
  .then(cart => {
    const cartItem = cart.items.find(item => item.variant_id === variantId);
    callback(cartItem ? cartItem.quantity : 0);
  })
  .catch(error => console.error("Error fetching cart data:", error));
}
function showBanner(message) {
  const banner = document.getElementById("preorder-warning-banner");
  const bannerText = document.getElementById("preorder-warning-text");
  bannerText.textContent = message;
  banner.style.top = "20px";
  setTimeout(() => {
    if (banner.style.top === "20px") {
      banner.style.top = "-300px";
    }
  }, 10000);
}
document.getElementById("preorder-close-btn").addEventListener("click", function () {
  document.getElementById("preorder-warning-banner").style.top = "-300px";
});
function checkPreorderLimit(variantId, selectedQuantity, pre_order_limit) {
  return new Promise((resolve) => {
    getCartQuantity(variantId, function (cartQuantity) {
      const totalQuantity = cartQuantity + selectedQuantity;
      if (totalQuantity > pre_order_limit) {
        showBanner(`Vi har kun ${pre_order_limit} igjen på lager`);
        resolve(true);
      } else {
        resolve(false);
      }
    });
  });
}